import { render, staticRenderFns } from "./popoverUserInfo.vue?vue&type=template&id=cf482110&scoped=true&"
import script from "./popoverUserInfo.vue?vue&type=script&lang=js&"
export * from "./popoverUserInfo.vue?vue&type=script&lang=js&"
import style0 from "./popoverUserInfo.vue?vue&type=style&index=0&id=cf482110&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf482110",
  null
  
)

export default component.exports